import _template from 'lodash/template';

export function createTemplateString(string) {
  return _template(string, { interpolate: /{{([\s\S]+?)}}/g });
}

export function formatString(string, vars = {}) {
  return createTemplateString(string)(vars);
}



// WEBPACK FOOTER //
// ./src/lib/templates.js